import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";

interface DateInputProps {
  label: string;
  date?: string | Date;
  onChange: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
}

const DateInput = ({
  label,
  date,
  onChange,
  minDate,
  maxDate,
  className = "date-input-group",
}: Readonly<DateInputProps>) => {
  let dateValue: Date | undefined = undefined;
  if (typeof date === "string") {
    dateValue = new Date(date);
  } else {
    dateValue = date;
  }
  return (
    <Form.Group className={`form-group ${className}`}>
      <Form.Label className="textarea-label">{label}</Form.Label>
      <DatePicker
        selected={dateValue}
        onChange={(date: Date | null) => {
          onChange(date);
        }}
        showTimeSelect
        dateFormat="Pp"
        placeholderText="Select a date"
        minDate={minDate}
        maxDate={maxDate}
      />
    </Form.Group>
  );
};

export default DateInput;
